module.exports = __webpack_public_path__ + "static/media/medical-history.cb63a1cd.svg";